import type { NotificationSettingsCardProps } from "@/ui/components/notificationSettings/NotificationSettingsCard";
import NotificationSettingsCard from "@/ui/components/notificationSettings/NotificationSettingsCard";
import type { NotificationSettingsSectionProps } from "@/ui/components/notificationSettings/NotificationSettingsSection";
import NotificationSettingsSection from "@/ui/components/notificationSettings/NotificationSettingsSection";

export { NotificationSettingsCard, NotificationSettingsSection };
export type { NotificationSettingsCardProps, NotificationSettingsSectionProps };
